import React, { useState } from "react";
import styles from "./ClientForm.module.css";

function PurchaseDetails({ formData, setFormData, nextStep }) {
  const [errors, setErrors] = useState({});

  const updateField = (field, value) => {
    setFormData({ ...formData, [field]: value });
    setErrors({ ...errors, [field]: "" }); // clear error when user types
  };

  const formatCurrency = (value) => {
    if (!value) return "";
    const number = value.toString().replace(/[^0-9]/g, "");
    return number ? Number(number).toLocaleString() : "";
  };

  const handleCurrencyChange = (field, e) => {
    const rawValue = e.target.value.replace(/[^0-9]/g, "");
    updateField(field, rawValue);
  };

  // Calculate deposit percentage
  const depositPercent =
    formData.purchasePrice && formData.deposit
      ? ((formData.deposit / formData.purchasePrice) * 100).toFixed(1)
      : null;

  const depositMessage =
    depositPercent && parseFloat(depositPercent) >= 5 ? "Great Job!" : "";

  // Validation before going to next step
  const handleNext = () => {
    let newErrors = {};

    if (!formData.isFirstHomeBuyer) {
      newErrors.isFirstHomeBuyer = "Please select Yes or No";
    }
    if (!formData.purchasePrice || formData.purchasePrice <= 0) {
      newErrors.purchasePrice = "Purchase price is required";
    }
    if (!formData.deposit || formData.deposit <= 0) {
      newErrors.deposit = "Deposit is required";
    }
    if (!formData.timeline) {
      newErrors.timeline = "Please select when you are planning to buy";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      nextStep();
    }
  };

  return (
    <div className={styles.container}>
      <h3>Purchase Details</h3>

      <p>Are you a first home buyer?</p>
      <div className={styles.buttonGroup}>
        <button
          type="button"
          className={formData.isFirstHomeBuyer === "Yes" ? styles.activeBtn : ""}
          onClick={() => updateField("isFirstHomeBuyer", "Yes")}
        >
          Yes
        </button>
        <button
          type="button"
          className={formData.isFirstHomeBuyer === "No" ? styles.activeBtn : ""}
          onClick={() => updateField("isFirstHomeBuyer", "No")}
        >
          No
        </button>
      </div>
      {errors.isFirstHomeBuyer && (
        <p className={styles.error}>{errors.isFirstHomeBuyer}</p>
      )}

      <p>What is your purchase price?</p>
      <div className={styles.currencyInputWithSuffix}>
        <span className={styles.prefix}>$</span>
        <input
          type="text"
          placeholder="e.g. $500,000"
          value={formData.purchasePrice ? formatCurrency(formData.purchasePrice) : ""}
          onChange={(e) => handleCurrencyChange("purchasePrice", e)}
        />
      </div>
      {errors.purchasePrice && (
        <p className={styles.error}>{errors.purchasePrice}</p>
      )}

      <p>How much deposit do you have?</p>
      <div className={styles.currencyInputWithSuffix}>
        <span className={styles.prefix}>$</span>
        <input
          type="text"
          placeholder="e.g. $50,000"
          value={formData.deposit ? formatCurrency(formData.deposit) : ""}
          onChange={(e) => handleCurrencyChange("deposit", e)}
        />
        {depositPercent && (
          <span className={styles.suffix} style={{ color: "#141414", fontWeight: "bold" }}>
            {depositPercent}% {depositMessage}
          </span>
        )}
      </div>
      {errors.deposit && <p className={styles.error}>{errors.deposit}</p>}

      <p>When are you planning to buy?</p>
      <div className={styles.buttonGroup}>
        {["ASAP", "3 months", "6 months"].map((option) => (
          <button
            key={option}
            type="button"
            className={formData.timeline === option ? styles.activeBtn : ""}
            onClick={() => updateField("timeline", option)}
          >
            {option}
          </button>
        ))}
      </div>
      {errors.timeline && <p className={styles.error}>{errors.timeline}</p>}

      <div className={styles.navBtns}>
        <button className={styles.nextBtn} onClick={handleNext}>
          Next →
        </button>
      </div>
    </div>
  );
}

export default PurchaseDetails;
